import React from "react";
import { createPortal } from "react-dom";

export default function DetailOverlay({ title, onClose, children }) {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="detail-overlay-backdrop" role="presentation" onMouseDown={onClose}>
      <div
        className="detail-overlay-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="detail-overlay-header">
          <h2>{title}</h2>
          <button type="button" className="detail-overlay-close" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="detail-overlay-body">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
